import { Component , ViewChild} from "@angular/core";
import { Router } from "@angular/router";
import { Observable, empty,forkJoin } from "rxjs";
import { DataService } from "../services/dataService";
import { Alert } from "../shared/modal/alert"
import { map,  catchError } from 'rxjs/operators';

@Component({
    selector: "jax-notifcationcomponent",
    templateUrl: "./documentNotification.component.html"
})

export class DocumentNotificationComponent {
    public data;
    public filterQuery = "";
    public rowsOnPage = 20;
    public sortBy = "UploadedDate";
    public sortOrder = "desc";
    public totalRecord = 0;
    public isCompleted = false;
    public hasError = false;
    public errorMessage: string;
    public userId: number;
    public currentUser: any;
    public istoplevelCheckBoxChecked: boolean;
    public searchFields: NotificationSearchFields[] = new Array();
    public searchFieldId: string = "";
    public unreadCount :number;
    @ViewChild(Alert) alert: Alert;


    constructor(private dataService: DataService, private router: Router) {
    }

    public ngOnInit() {
        this.isCompleted = false;
        this.istoplevelCheckBoxChecked = false;
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.userId = this.currentUser.UserId;
        }
        this.loadNotifications();   
        this.getSearchFields();
    }

    public onchange(pageEvent) {
        this.totalRecord = pageEvent.dataLength;
        this.rowsOnPage > 60 ? this.rowsOnPage = 20 : this.rowsOnPage = this.rowsOnPage;
    }

    public openPdf(event,item: any) {
        var isJaxOnlyDocument = false;
        var uploadedDate = new Date(item.UploadedDate);
        var date = new Date(2025, 3, 30, 23, 59, 59);
        if (item.DocumentTypeID === 37232555 && uploadedDate > date)     
        {
            isJaxOnlyDocument = true;
        }
        this.dataService.sharedService.openPopupWindow();
        this.dataService
            .getPdf("document/document?documentID=" + item.DocumentID + "&documentName=" + encodeURIComponent(item.DocumentName) + "&isJaxOnlyDocument=" + isJaxOnlyDocument).subscribe(
                (res) => {
                    this.dataService.sharedService.displayPdf(res,item.DocumentName);
                },
                (error) => {
                    this.dataService.sharedService.closePopupWindow();
                }
            );
        event.stopPropagation();
    }

    public checkAll(ev) {
        this.data.forEach(obj => obj.Delete = ev);
    }
   
    public markRowAsReadUnRead(event,item: any){
        let objIndex = this.data.findIndex((obj => obj.ID === item.ID));
        let observables = new Array();
        if (item.NotificationStatus===0) {
            this.data[objIndex].NotificationStatus = 1;
        }
        else if (item.NotificationStatus === 4) {
                this.data[objIndex].NotificationStatus = 5;
        }
        else if (item.NotificationStatus === 5) {
            this.data[objIndex].NotificationStatus = 4;
        }
        else {
            this.data[objIndex].NotificationStatus = 0;
        }
        observables.push(this.updateNotificationStatus(item.ID, this.data[objIndex].NotificationStatus));
        forkJoin(observables).subscribe(
            (resp) => { });
        event.stopPropagation();
    }

    public topLevelChange(ev, toplevelCheckBox) {
        let checkedcount = this.data.filter(obj => obj.Delete === true).length;
        if (checkedcount == 0) {
            toplevelCheckBox.checked = false;
            toplevelCheckBox._checkbox.nativeElement.indeterminate = false;
        }
        else if (checkedcount < this.data.length) {
            toplevelCheckBox.checked = false;
            toplevelCheckBox._checkbox.nativeElement.indeterminate = true;
        } else {
            toplevelCheckBox.checked = true;
            toplevelCheckBox._checkbox.nativeElement.indeterminate = false;
        }
    }

    public deleteNotifications() {
        let checkedNotifications = this.data.filter(obj => obj.Delete === true);
        let deleteCount = 0;
        let observables = new Array();
        for (let obj of checkedNotifications) {
            observables.push(this.updateNotificationStatus(obj.ID, 2));
            deleteCount++;
        }

        forkJoin(observables).subscribe(
            (res) => {
                if (deleteCount > 0) {
                    this.loadNotifications();
                }
            });
    }

    public confirmOpen() {
        this.alert.cancelButton = true;
        this.alert.okButton = true;
        this.alert.alertTitle = "Delete Notification(s)?";
        this.alert.message = "This will delete your selected notification and cannot be recovered.<br>Do you want to continue?";
        this.alert.okButtonText = "Yes";
        this.alert.okButtonType = "btn-danger";
        this.alert.cancelButtonText = "No";

        let checkedNotifications = this.data.filter(obj => obj.Delete === true);
        if (checkedNotifications.length === 0) {
            this.alert.message = "No notification is selected for delete.";
            this.alert.okButton = false;
            this.alert.cancelButtonText = "Ok";
        }
        this.alert.open();
    }

    public confirmClose(event) {
        let e = event;
        this.deleteNotifications();
    }
    public getSearchFields(): void {
        let notificationfield = new NotificationSearchFields();
        this.searchFields.push(notificationfield);
        notificationfield = new NotificationSearchFields();
        notificationfield.Id = "filterQuery0";
        notificationfield.Name = "CaseNumber";
        this.searchFields.push(notificationfield);

        notificationfield = new NotificationSearchFields();
        notificationfield.Id = "filterQuery1";
        notificationfield.Name = "DocumentType";
        this.searchFields.push(notificationfield);

        notificationfield = new NotificationSearchFields();
        notificationfield.Id = "filterQuery2";
        notificationfield.Name = "DocumentName";
        this.searchFields.push(notificationfield);

        notificationfield = new NotificationSearchFields();
        notificationfield.Id = "filterQuery3";
        notificationfield.Name = "UploadedDate";
        this.searchFields.push(notificationfield);

        notificationfield = new NotificationSearchFields();
        notificationfield.Id = "filterQuery4";
        notificationfield.Name = "UploadedBy";
        this.searchFields.push(notificationfield);
    }

    private updateNotificationStatus(documentNotificationId: number, status: number): Observable<any> {
        return this.dataService.get("document/updatenotificationstatus?documentNotificationId=" +
            documentNotificationId +
            "&status=" +
            status +
            "&userId=" +
            this.userId).pipe(map(
            (response) => {
                if (response) {
                    if (status === 0 || status === 4) {
                        this.unreadCount++;
                    } else {
                        this.unreadCount--;
                    }
                    return response;
                }
            },
            (error) => {
            }));
    }

    public documentNotification(NotificationStatus: number)
    {
        if (NotificationStatus == 4) 
            return ": line-through";
        else
            return "";
    }

    private loadNotifications(): void {
        this.istoplevelCheckBoxChecked = false;
        this.isCompleted = false;
        let unreadData: any = "";
        this.dataService.get("document/notification?UserId=" + this.userId).subscribe(
            (response) => {
                this.data = response,
                    unreadData = this.data.filter(d => d.NotificationStatus === 0 || d.NotificationStatus === 4);
                this.unreadCount = unreadData.length;
                        this.isCompleted = true,
                        this.totalRecord = this.data.length;
                    this.data.forEach(obj => obj.Delete = false);
            },
            (error) => {
                this.errorMessage = error.message;
                this.isCompleted = true;
                this.hasError = true;
            });
    }

    public canViewDocument() {
        if (this.currentUser.Security.search("vintJAXDocumentView") >= 0)
            return true;
        else
            return false;
    }
}

export class NotificationSearchFields {
    public Id: string;
    public Name: string;
    constructor() {
        this.Id = "";
        this.Name = "--Select--";
    }
}
